import { useQuery } from '@tanstack/react-query';
import { classNames } from '../tools/helpers';
import { getSite } from '../tools/fetcher';

export default function Slogan({ className }) {
    const { data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    const slogans = [
        {
            icon: 'verified',
            imageSrc: data.slogan_verified?.image_src,
            imageAlt: data.slogan_verified?.image_alt,
            description: data.slogan_verified?.description,
        },
        {
            icon: 'hand',
            imageSrc: data.slogan_hand?.image_src,
            imageAlt: data.slogan_hand?.image_alt,
            description: data.slogan_hand?.description,
        },
        {
            icon: 'safety',
            imageSrc: data.slogan_safety?.image_src,
            imageAlt: data.slogan_safety?.image_alt,
            description: data.slogan_safety?.description,
        },
    ];

    const imageLarge = {
        imageSrc: data?.slogan_image_large?.image_src,
        imageAlt: data?.slogan_image_large?.image_alt,
    };

    const imageSmall = {
        imageSrc: data?.slogan_image_small?.image_src,
        imageAlt: data?.slogan_image_small?.image_alt,
    };

    return (
        <div className={classNames('grid sm:grid-cols-2 gap-10', className)}>
            <div className={'hidden sm:grid sm:grid-cols-10 max-w-[440px]'}>
                {imageLarge?.imageSrc && (
                    <img
                        src={imageLarge?.imageSrc}
                        alt={imageLarge?.imageAlt || 'Eat on sofa'}
                        className={
                            'sm:col-span-6 w-full h-auto object-contain rounded-[20px]'
                        }
                    />
                )}
                <div
                    className={
                        "sm:col-span-4 bg-[url('/public/assets/dot/dot-green-1.png')] bg-no-repeat bg-center"
                    }
                />
                <div
                    className={
                        "sm:col-span-6 bg-[url('/public/assets/dot/dot-green-2.png')] bg-no-repeat bg-center"
                    }
                />
                {imageSmall?.imageSrc && (
                    <img
                        src={imageSmall?.imageSrc}
                        alt={imageSmall?.imageAlt || 'Eat on sofa'}
                        className={
                            'sm:col-span-4 w-full h-auto object-contain rounded-[20px]'
                        }
                    />
                )}
            </div>
            <div>
                <h1
                    className={
                        'text-[32px] leading-[40px] sm:text-[40px] font-bold sm:leading-[48px]'
                    }
                >
                    {data?.slogan?.title ||
                        'Nikmati kemudahan mencari tempat kost idaman'}
                </h1>
                <p className={'leading-[28px] text-apart-black-50 mt-4'}>
                    {data?.slogan?.description ||
                        `Layanan mudah dan cepat membuat kamu gak perlu lagi berlama - lama mencari kost yang sesuai dengan yang kamu mau. Langsung booking dan bayar!`}
                </p>
                <ul
                    className={
                        'flex flex-col sm:grid grid-cols-3 gap-4 sm:gap-10 mt-8'
                    }
                >
                    {slogans.map((slogan, index) => (
                        <li
                            key={index}
                            className={
                                'text-base leading-[24px] sm:text-[20px] sm:leading-[32px] flex items-center sm:items-start flex-row sm:flex-col gap-6'
                            }
                        >
                            <div
                                className={
                                    'flex items-center justify-center h-[48px] w-[48px] sm:h-[60px] sm:w-[60px] bg-apart-green-10 rounded-full'
                                }
                            >
                                <img
                                    src={slogan.imageSrc}
                                    alt={slogan.imageAlt || slogan.icon}
                                />
                            </div>
                            <b>{slogan.description}</b>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
